import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestResponse } from "../model/dto/RequestResponse";
import { PriceLabelSection } from "../model/PriceLabelSection";

@Injectable()
export class PriceLabelSectionFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetAll(): Observable<RequestResponse<PriceLabelSection[]>> {
        return this._httpClient.get<any>(this._urlBase + 'api/PriceLabelSection/');
    }

    GetByOrganization(organizationId: String): Observable<RequestResponse<PriceLabelSection>> {
        return this._httpClient.get<RequestResponse<PriceLabelSection>>(
            this._urlBase + 'api/PriceLabelSection/ByOrganization?organizationId=' + organizationId);
    }
}